import React from "react";
import { Card, Badge } from "react-bootstrap";
import { CheckCircle2, Circle, Pencil } from "lucide-react";
import "./RoundTimeline.scss"; // custom SCSS

function formatDate(dateStr) {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  return date.toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
    timeZone: "Asia/Kolkata",
  });
}

const statusColors = {
  Passed: "success",
  Completed: "success",
  "In Progress": "warning",
  Scheduled: "primary",
  Failed: "danger",
};

const statusBadgeClass = {
  Passed: "passed",
  Completed: "passed",
  "In Progress": "inprogress",
  Scheduled: "scheduled",
  Failed: "failed",
};

const RoundTimeline = ({ rounds = [], onEdit }) => (
  <div className="custom-timeline">
    {rounds.map((r, idx) => (
      <div className="timeline-row d-flex" key={r._id || idx}>
        {/* Timeline tick/line */}
        <div className="timeline-icon-col">
          <div
            className={`timeline-icon ${
              r.status === "Passed" || r.status === "Completed"
                ? "done"
                : r.status === "Scheduled"
                ? "scheduled"
                : ""
            }`}
          >
            {r.status === "Passed" || r.status === "Completed" ? (
              <CheckCircle2 size="1em" className="interview-step step-success" />
            ) : r.status === "Rejected" || r.status === "Failed" ? (
              <Circle size="1em" className="interview-step step-failed" />
            ) : (
              <Circle size="1em" className="interview-step step-pending" />
            )}
          </div>
          {idx < rounds.length - 1 && <div className="timeline-line"></div>}
        </div>
        {/* Card */}
        <div className="flex-grow-1">
          <Card
            className={
              `timeline-card mb-4` +
              (r.status === "Scheduled" ? " scheduled" : "") +
              (r.status === "Failed" ? " failed" : "") +
              (r.status === "In Progress" ? " inprogress" : "") +
              (r.status === "Passed" ? " passed" : "") +
              (r.status === "Completed" ? " completed" : "")
            }
          >
            <Card.Body>
              <div className="d-flex justify-content-between align-items-start">
                <div>
                  <div className="fs-5 mb-1">{r.round}</div>
                  <div className="mb-2 text-muted small">
                    Date: {formatDate(r.date)} {r.time && `at ${r.time}`}
                    {r.duration && <> &nbsp; &nbsp; Duration: {r.duration}</>}
                    {r.mode && <> &nbsp; &nbsp; Mode: {r.mode}</>}
                  </div>
                  {r.meetingLink && (
                    <div className="mb-2 text-muted small">
                      Meeting Link: {r.meetingLink ? (
                        <a
                          href={r.meetingLink}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {r.meetingLink}
                        </a>
                      ) : (
                        "N/A"
                      )}
                    </div>
                  )}
                  {r.interviewers && r.interviewers.length > 0 && (
                    <div className="mb-2 text-muted small">
                      Interviewers:{" "}
                      {r.interviewers.map((iv, i) => (
                        <Badge key={iv._id || i} bg="info" className="me-1" style={{ fontWeight: 500 }}>
                          {iv.name || iv}
                        </Badge>
                      ))}
                    </div>
                  )}
                  {r.notes && <div style={{ fontSize: 15 }}>{r.notes}</div>}
                  {onEdit && (
                    <div>
                      <span className="edit-link" onClick={() => onEdit(r, idx)}>
                        <Pencil size="1em" style={{ marginRight: 4, verticalAlign: -2 }} />
                        Edit Details
                      </span>
                    </div>
                  )}
                </div>
                {/* Status badge floats top right */}
                <Badge
                  bg=""
                  className={`status-badge ${statusBadgeClass[r.status] || ""}`}
                >
                  {r.status}
                </Badge>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
    ))}
  </div>
);

export default RoundTimeline;
